const packageJson = require('../package.json');

export const SCRIPT_ID = process.env.REACT_APP_SCRIPT_ID || '';
export const ENV = process.env.REACT_APP_API_ENV || 'MOCK';

export const AVAILABLE_MAIN_API_LIST = JSON.parse(
	process.env.REACT_APP_AVAILABLE_MAIN_API_LIST ||
		'{"MOCK":"https://63314fd6cff0e7bf70ea30ff.mockapi.io/api/v1/rmc/web-","STG":"https://stg-rmc-cx.api.rakuten.co.jp/v2/web/","PROD":"https://rmc-cx.api.rakuten.co.jp/v2/web/"}'
);

export const AVAILABLE_TRACK_API_LIST = JSON.parse(
	process.env.REACT_APP_AVAILABLE_TRACK_API_LIST ||
		'{"MOCK":"https://stg-rmc-cx.api.rakuten.co.jp/v2/web/","STG":"https://stg-rmc-cx.api.rakuten.co.jp/v2/web/","PROD":"https://rmc-cx.api.rakuten.co.jp/v2/web/"}'
);

export const VERSION = packageJson.version;
export const RAT_PROJECT_KEY = 'RMCCX_BLOCKS';

export const REQUEST_TIME_OUT = 500;
